export const mensagemObrigatorio = (campo) => {
  return `O campo ${campo} é obrigatório`;
};
